import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AlertController, ModalController } from '@ionic/angular';

import { GlobalService } from '../global.service';
import { AjaxService } from '../ajax.service';
import { RecordFormPage } from '../record-form/record-form.page';

type TableData = {
    hdr: [],
    rows: [],
    ftr: []
}

@Component({
    selector: 'app-uren',
    templateUrl: './uren.page.html',
    styleUrls: ['./uren.page.scss'],
    standalone: false
})

export class UrenPage {
    tab='dag';
    DD = new Date();
    DDtxt = '';
    msg = '';
    uren: any[] = [];
    fields = [];
    werktijden: any = {};
    week: TableData;
    total: 0;
    TStartDag = null;

    constructor(
        private router: Router,
        public global: GlobalService,
        public alertController: AlertController,
        public modalController: ModalController,
        private datepipe: DatePipe,
        private ajax: AjaxService,
    ) { }

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            this.router.navigateByUrl('login');
        }
    }

    ionViewWillEnter() {
        this.chDD(0);
    }

    setDD(newDate) {
        this.DD = new Date(newDate);
        this.tab = 'dag';
        this.chDD(0);
    }

    chDD(delta: number) {
        if (this.tab==='week') {
            delta = delta * 7;
        }
        this.DD.setDate(this.DD.getDate()+delta);
        if (this.tab==='dag') {
            this.DDtxt = 'Uren ' + this.DD.toLocaleDateString('nl-NL');
            this.ajax.get('uren', {DD: this.DD.toLocaleDateString('nl-NL')})
            .then((data:any)=>{
                if (!data.login) {
                    this.router.navigateByUrl('login');
                } else {
                    this.uren = (data.uren) ? data.uren: [];
                    this.total = data.total;
                    this.TStartDag = data.startdag;
                    this.fields = data.werktijd_velden;
                    this.werktijden = data.werktijden;
                    this.werktijden.wuCheck1 = (this.werktijden.wuCheck1==='1');
                    this.werktijden.wuCheck2 = (this.werktijden.wuCheck2==='1');
                }
            });
        } else {
            // tab==='week'
            this.ajax.get('weekuren', {DD: this.DD.toLocaleDateString('nl-NL')})
            .then((data:any)=>{
                console.log('weekuren', data);
                if (!data.login) {
                    this.router.navigateByUrl('login');
                } else {
                    this.week = data.tbl;
                    this.DDtxt = data.WKtxt;
                    this.msg = data.msg;
                }
            });
        }
    }

    async addUren() {
        const urenDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'uren',
                id: '*NEW*',
                defaults: {
                    DD: this.datepipe.transform(this.DD, 'yyyy-MM-dd')
                },
            }
        });
        urenDlg.onDidDismiss()
        .then(data=>{
            this.chDD(0);
        });
        return await urenDlg.present();
    }

    async editUren(editID) {
        const urenDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'uren',
                id: editID,
                defaults: {},
            }
        });
        urenDlg.onDidDismiss()
        .then(data=>{
            this.chDD(0);
        });
        return await urenDlg.present();
    }

    startDag() {
        this.ajax.get('startDag')
        .then((data: any) => {
            this.TStartDag = data.startdag;
        });
    }

    setTab(set) {
        this.tab=set;
        console.log('tab=', this.tab);
        this.chDD(0);
    }

    changeField() {
        let myWerktijden = Object.assign({}, this.werktijden);
        myWerktijden['wuCheck1'] = (this.werktijden['wuCheck1']) ? '1': '0';
        myWerktijden['wuCheck2'] = (this.werktijden['wuCheck2']) ? '1': '0';
        delete myWerktijden['allowEdit'];
        this.ajax.get('updateRecord', {
            table: 'werktijden',
            fields: myWerktijden,
            where: "wuID='"+this.werktijden.wuID+"'",
        }).then((data:any)=>{
            //console.log('changeField -> updateRecord', data);
        });
    }
}
